import { render, staticRenderFns } from "./save-info.vue?vue&type=template&id=8ccfc520&scoped=true&"
import script from "./save-info.vue?vue&type=script&lang=js&"
export * from "./save-info.vue?vue&type=script&lang=js&"
import style0 from "./save-info.vue?vue&type=style&index=0&id=8ccfc520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccfc520",
  null
  
)

export default component.exports